import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {environment} from '../../../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {language} from '../../../../language/vn';
import {Thu} from '../../../../models/email/thu';
import {ThuService} from '../../../../service/email/service-thu';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {EditThuComponent} from '../soanthu/edit.component';
import {ChenHoSoThuGuiComponent} from '../chenhoso/thugui.component';
import {ChenHoSoThuComponent} from '../chenhoso/chenhoso.component';
import {CTThuNhanComponent} from '../chuyentrinh/thunhan.component';
import {GVThuNhanComponent} from '../giaoviec/thunhan.component';
import {CommandUtil} from '../../../../global/commandutil';
@Component({
  templateUrl: './thudaxoa.component.html',

})
export class ThuDaXoaComponent implements OnInit, AfterViewInit {
  public language = language;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public frmGroup: FormGroup;
  public dataList: Thu[];
  public submitValidate = false;
  public srChuDe: string = '';
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public read: number = -1;
  public del: number = 1;
  public nguoiNhan: number = Sessioncommand.staffId;
  public checked: boolean = false;
  public dataCheck: Object[]=[];
  constructor(
    public thuService: ThuService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public commandUtil: CommandUtil
  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  public deleteAll(): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_message_thungrac_all_mail,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.thuService.deleteAllByNguoiNhan(this.nguoiNhan, 1, 2).subscribe({
          next: () => {
            this.toastr.success(language.message_thungrac_mail, language.message);
            this.search();
            Sessioncommand.emailStatus =0 ;


          },
          error: error => {
            this.toastr.error(language.error, language.message);
          }
        });
      }
    });
  }
  public deleteAllByCheck(): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_message_thungrac_mail,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.thuService.deleteAllByIds(this.dataCheck.join(), 1,2).subscribe({
          next: () => {
            this.toastr.success(language.message_thungrac_mail, language.message);
            this.search();
            Sessioncommand.emailStatus =0 ;
          },
          error: error => {
            this.toastr.error(language.error, language.message);
          }
        });
      }
    });
  }
  public readAllByCheck(): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_read_question_check,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.thuService.readAllByIds(this.dataCheck.join(),1, 0).subscribe({
          next: () => {
            this.toastr.success(language.read_success_record, language.message);
            this.search();
          },
          error: error => {
            this.toastr.error(language.error, language.message);
          }
        });
      }
    });
  }
  ngOnInit(): void {

    this.search();
  }
  public checkAll(event)
  {
    this.dataCheck=[];
    this.checked= event.target.checked;
    if(event.target.checked == true)
    {
      for(let i=0;i< this.dataList.length;i++)
        this.dataCheck.push(this.dataList[i].id);
    }
  }
  public checkedItem(event)
  {

    if(event.target.checked== true && this.dataCheck.indexOf(event.target.value) ==-1)
      this.dataCheck.push(event.target.value);
    else
      this.commandUtil.removeItem(event.target.value, this.dataCheck);
    if(this.dataCheck.length==0)
      this.checked=false;
  }
  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_message_thungrac_mail,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }

  public edit(id: number) {
    const modalEdit = this.bsModalService.show(EditThuComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<EditThuComponent>modalEdit.content).edit(
      id
    );
    (<EditThuComponent>modalEdit.content).onClose.subscribe(result => {
      if(result === true)
        this.search();

    });

  }
  public chuyenTrinh(id: string) {
    const modalEdit = this.bsModalService.show(CTThuNhanComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<CTThuNhanComponent>modalEdit.content).edit(
      Number(id!=''? id: '0')
    );
    (<CTThuNhanComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  public chuyenGiaoViec(id: string) {
    const modalEdit = this.bsModalService.show(GVThuNhanComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<GVThuNhanComponent>modalEdit.content).edit(
      Number(id!=''?id:'0')
    );
    (<GVThuNhanComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  public chenHoSo(id: number) {
    const modalEdit = this.bsModalService.show(ChenHoSoThuComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<ChenHoSoThuComponent>modalEdit.content).edit(
      id
    );
    (<ChenHoSoThuGuiComponent>modalEdit.content).onClose.subscribe(result => {


    });

  }
  search()
  {
    this.thuService.findAllByPaging(this.srChuDe, this.nguoiNhan, this.read, this.del, '-1', this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.thuService.getCountByKeyword(this.srChuDe, this. nguoiNhan, this.read, this.del, '-1').subscribe(recordCount => this.totalItems = recordCount);
  }
  deleteItem(id: number)
  {
    this.thuService.deleteAllByIds(id.toString(), 1,2).subscribe({
      next: () => {
        this.toastr.success(language.message_thungrac_mail, language.message);
        this.search();
        Sessioncommand.emailStatus =0 ;
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

